import { createSlice } from "@reduxjs/toolkit";
import { DEFAULT_GATE_MODE } from "constants/proposals";

export const initialState = {
  categories: [],
  isLoading: false,
  gateMode: DEFAULT_GATE_MODE,
  isKanbanStale: false,
  kanbanVersion: 0,
};

export const proposalsSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    reset: () => initialState,
    setCategories: (state, action) => {
      state.categories = action.payload;
      state.isKanbanStale = false;
    },
    markKanbanStale(state) {
      state.isKanbanStale = true;
      state.kanbanVersion += 1;
    },
    setIsLoading(state, { payload: isLoading = false }) {
      state.isLoading = isLoading;
    },
    updateKanbanItemAssignees(state, { payload: { itemId, assignees } }) {
      state.categories.forEach((column) => {
        const proposal = (column.proposals || []).find(
          (row) => row.id === itemId
        );
        if (proposal) {
          proposal.assignees = assignees || [];
        }
      });
    },
    setGateMode(state, { payload }) {
      state.gateMode = payload;
    },
    removeProposalById(state, { payload }) {
      state.categories.forEach((column) => {
        column.proposals = (column.proposals || []).filter(
          ({ id }) => id !== payload
        );
      });
    },
  },
});

export const {
  reset,
  markKanbanStale,
  removeProposalById,
  setCategories,
  setIsLoading,
  updateKanbanItemAssignees,
  setGateMode,
} = proposalsSlice.actions;

export default proposalsSlice;
